<template>
  <div class="bundle-wrap bundle-wrap-left bundle-composition" :class="{ 'not-carousel': products.length === 1 }">
    <div class="bg-wrap">
      <div class="bg bg-img" :style="contentBgStyle"></div>
      <div class="bg bg-dimmed"></div>
    </div>
    <div class="composition-state">
      <span class="composition-total">총 {{ productTotal }}과목</span>
      <span class="composition-paging">{{ `${slideCurrent} / ${products.length}` }}</span>
    </div>
    <div class="composition-carousel">
      <ul v-if="products.length === 1">
        <bundle-product v-for="product in products[0]" :key="product.id" :product="product" />
      </ul>
      <VueSlickCarousel v-else :infinite="false" @afterChange="setPageNum">
        <ul v-for="(productGroup, idx) in products" :key="idx">
          <bundle-product v-for="product in productGroup" :key="product.id" :product="product" />
        </ul>
      </VueSlickCarousel>
    </div>
    <div v-if="goods" class="goods">
      <div class="goods-inner" :style="{ border: `1px solid ${pointColorRGBA}` }">
        <span class="goods-icon" :style="{ backgroundColor: pointColor }">추가구성</span>
        <span class="goods-desc" :style="{ color: pointColor }">{{ goods.title }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import BundleProduct from './bundle-product';

export default {
  props: ['productTotal', 'products', 'goods', 'coverImgUrl', 'pointColor'],
  components: { VueSlickCarousel, BundleProduct },
  computed: {
    contentBgStyle() {
      return {
        backgroundImage: `url(${this.coverImgUrl})`,
      };
    },
    pointColorRGBA() {
      return this.hexToRGB(this.pointColor, 0.3);
    },
  },
  data() {
    return {
      slideCurrent: 1,
    };
  },
  methods: {
    setPageNum(currentSlideIdx) {
      this.slideCurrent = currentSlideIdx + 1;
    },
    hexToRGB(h, opacity) {
      let r = 0,
        g = 0,
        b = 0;

      // 3 digits
      if (h.length == 4) {
        r = '0x' + h[1] + h[1];
        g = '0x' + h[2] + h[2];
        b = '0x' + h[3] + h[3];

        // 6 digits
      } else if (h.length == 7) {
        r = '0x' + h[1] + h[2];
        g = '0x' + h[3] + h[4];
        b = '0x' + h[5] + h[6];
      }
      return 'rgb(' + +r + ',' + +g + ',' + +b + ',' + opacity + ')';
    },
  },
};
</script>
